<template>
	<div>
		<div>
			<div style="
			          box-shadow: 0 0 5px 0 #eeeeee;
			          background-color: white;
			          height: 50px;
			          padding: 10px 10px;
			          display: flex;
			          justify-content: space-between;
			          align-items: center;
			        ">
				<div style="display: flex; align-items: center">
					<img src="/logo.jpg" style="width: 50px; height: 45px" />
					<div style="font-size: 22px; font-weight: 550; margin-left: 10px">
						日照市智慧残联工作平台
					</div>
					<el-button @click="tiaozhuan" type="primary" icon="el-icon-share"
						style="zoom: 75% ; margin-left: 2vw;">数据可视化</el-button>
				</div>
				<div style="
			            display: flex;
			            justify-content: center;
						align-items: flex-end;
			            flex-direction: column;
			            margin-right: 10px;
			          ">
					<div style="display: flex;">
						<div>{{org.name}}</div>
						<div style="margin-left: 10px;">{{ info.name }}</div>
					</div>

					<div>
						<el-button v-if="info.uid!=0" @click="changepsd" style="color:orange" type="text">修改密码
						</el-button>
						<el-button @click="tuichu" type="text">退出登录</el-button>
					</div>

				</div>
			</div>
		</div>
		<div class="rongqi">
			<div>
				<menus></menus>
			</div>
			<router-view class="zhuta">

			</router-view>
		</div>
	</div>

</template>

<script>
	import menus from "../components/menus.vue"
	export default {
		data() {
			return {
				restaurants: [],
				kechen_bz: '',
			}
		},
		components: {
			menus
		},
		computed: {
			info() {
				let info = window.localStorage.getItem("info");
				return JSON.parse(info);
			},
			org() {
				let org = window.localStorage.getItem("org");
				return JSON.parse(org);
			}
		},
		mounted() {
			this.restaurants = this.loadAll();
		},
		methods: {
			loadAll() {
				return [{
						"value": "180分钟",
						"address": "180"
					}
				];
			},
			handleSelect(item) {
				console.log(item);
			},
			querySearch(queryString, cb) {
				var restaurants = this.restaurants;
				var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
				// 调用 callback 返回建议列表的数据
				cb(results);
			},
			tiaozhuan() {
				window.open("http://etkfctu.heiban.icu/index.html?qu_id=" + this.org.area)
			},
			tuichu() {
				window.localStorage.removeItem("info");
				window.localStorage.removeItem("org");
				this.$router.push("/login");
			},
			changepsd() {
				this.$prompt('请输入新密码', '修改新密码', {
					confirmButtonText: '确定',
					cancelButtonText: '取消'
				}).then(({
					value
				}) => {
					axios.post(this.$url + "admin/changePSD", {
						token: this.info.uid,
						newpsd: value
					}).then(ans => {
						this.$message({
							type: 'success',
							message: ans.data.desc
						});
					}).catch(e => {
						console.log(e);
					});

				}).catch(() => {
					this.$message({
						type: 'info',
						message: '取消输入'
					});
				});
			}
		},
		created() {
			let token = window.localStorage.getItem("info");
			token = JSON.parse(token);
			if (token.uid) {

			} else {
				this.$router("/login");
			}
		}
	}
</script>

<style>
	.rongqi {
		display: flex;
		height: calc(100vh - 80px);
	}

	.zhuta {
		width: calc(100vw - 180px);
		height: calc(100vh - 120px);
		padding: 20px 20px;
	}
</style>